import {saveAs} from 'file-saver';
import JSZip from 'jszip';
/**
 * Télécharge un fichier depuis une URL et le retourne sous forme de Blob
 */
async function fetchFile(url: string): Promise<Blob> {
  const headers = new Headers();
  headers.append('accept', `application/json`);
  const requestOptions: RequestInit = {
    headers: headers,
    redirect: 'follow',
    mode: 'cors',
    cache: 'no-store',
  };
  const req = await fetch(url, requestOptions);
  const response = await req;

  if (!response.ok) {
    throw new Error(`Échec du téléchargement : ${url}`);
  }
  return await response.blob();
}

/**
 * Télécharge une liste de fichiers et génère un ZIP téléchargeable
 * @param urls Liste des URLs publiques
 * @param zipName Nom du fichier zip final
 */
export async function downloadFilesAsZip(urls: string[], zipName = 'archive.zip') {
  const zip = new JSZip();
  console.log('urls', urls);
  // Télécharger tous les fichiers en parallèle
  const files = await Promise.all(
    urls.map(async (url, index) => {
      try {
        const blob = await fetchFile(url);
        // Récupérer un nom de fichier depuis l'URL
        const fileName = url.split('/').pop() || `file-${index}`;
        zip.file(fileName, blob as any);
      } catch (err) {
        console.error(`Erreur avec ${url}:`, err);
      }
    }),
  );

  // Générer le zip
  const content = await zip.generateAsync({type: 'blob'});
  saveAs(content, zipName);
}
